module.exports = __webpack_public_path__ + "media/site/images/startups/tatralife-tablet-f7c4ef72c8a800808b39b3639d81fcf0.png";